import { render, staticRenderFns } from "./ApmsRegLaborEmploymentDetail.vue?vue&type=template&id=1504b1e8&scoped=true&"
import script from "./ApmsRegLaborEmploymentDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegLaborEmploymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504b1e8",
  null
  
)

export default component.exports